import * as Sentry from '@sentry/react';
import 'antd/dist/reset.css';
import App from 'App';
import 'index.css';
import 'overrides.scss';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { init as initializeUserpilot } from 'tools/Userpilot';

const sentryEnabled =
  import.meta.env.VITE_DISABLE_SENTRY !== 'true' &&
  window.location.hostname !== 'localhost' &&
  !/\.local$/.test(window.location.hostname);

Sentry.init({
  dsn: sentryEnabled
    ? 'https://3c83925833b6311da869b3f9bfcc3b1a@o4508086168125440.ingest.de.sentry.io/4508398790443089'
    : undefined,
  enabled: sentryEnabled,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/staging\.plateformeb2b\.hellio\.dev/,
    /^https:\/\/dev\.plateformeb2b\.hellio\.dev/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Initialize Userpilot
initializeUserpilot();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
